import Swiper from 'swiper/bundle';

export default function  initializeGalleryText(){
    if(document.querySelector('.block-gallery-text__swiper')) {
        let swiper = new Swiper( ".block-gallery-text__swiper", {
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}